import React from 'react';
import { Box, Slide, Alert, AlertTitle } from '@mui/material';
import { useNotifications } from '../hooks/useNotifications';

interface NotificationProps {
  notification: {
    id: string;
    message: string;
    type: 'success' | 'error' | 'info' | 'warning';
    autoDismiss?: boolean;
  };
}

export const Notification: React.FC<NotificationProps> = ({ notification }) => {
  const { notifications, removeNotification } = useNotifications();

  return (
    <Slide direction="up" in={notifications.length > 0} mountOnEnter unmountOnExit>
      <Box
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 1300,
        }}
      >
        {notifications.map((notification) => (
          <Alert
            key={notification.id}
            severity={notification.type}
            onClose={() => removeNotification(notification.id)}
            sx={{ mb: 2 }}
          >
            {notification.message}
          </Alert>
        ))}
      </Box>
    </Slide>
  );
};


